import * as React from 'react';
import {
	Create,
	CreateProps,
	DateInput,
	SimpleForm,
	TextInput
} from 'react-admin';

export const LiveTrainingMessageCreate = (props: CreateProps): React.ReactElement => {
	return (
		<Create {...props}>
			<SimpleForm>
				<TextInput source="content" label="CONTENT"/>
				<DateInput source="date" label="DATE"/>
			</SimpleForm>
		</Create>
	);
};
